import {
  MainButton,
  type MainButtonProps,
} from '@/shared/ui/Buttons/MainButton.tsx';
import { FormattedMessage } from 'react-intl';
import { AccountIcon } from '../../icons/AccountIcon.tsx';
import { LIGHT_COLOR } from '../../styles/colors-js.ts';

export const CabinetLinkButton = ({ ...props }: MainButtonProps) => {
  return (
    <MainButton {...props}>
      <div className="flex items-center gap-2 px-6">
        <FormattedMessage defaultMessage="Личный кабинет" />
        <AccountIcon color={LIGHT_COLOR} />
      </div>
    </MainButton>
  );
};
